import React from "react";

// ทำการ import ไฟล์ SVG แต่ละไฟล์โดยตรง
import { ReactComponent as LogoIcon } from "../figs/svgs/logo.svg";
import { ReactComponent as BgIcon } from "../figs/svgs/bg.svg";
import { ReactComponent as DeleteIcon } from "../figs/svgs/bin.svg";
import { ReactComponent as DeleteIcon2 } from "../figs/svgs/bin-2.svg";
import { ReactComponent as BoatSettingsIcon } from "../figs/svgs/boat-settings.svg";
import { ReactComponent as BoatIcon } from "../figs/svgs/boat.svg";
import { ReactComponent as CalendarIcon } from "../figs/svgs/calendar.svg";
import { ReactComponent as ClockIcon } from "../figs/svgs/clock.svg";
import { ReactComponent as DataEditIcon } from "../figs/svgs/data-edit.svg";
import { ReactComponent as DataEntryIcon } from "../figs/svgs/data-entry.svg";
import { ReactComponent as EmptyImageIcon } from "../figs/svgs/empty-image.svg";
import { ReactComponent as EmptyNotiIcon } from "../figs/svgs/empty-noti.svg";
import { ReactComponent as HasNotiIcon } from "../figs/svgs/has-noti.svg";
import { ReactComponent as HomeIcon } from "../figs/svgs/home.svg";
import { ReactComponent as BackIcon } from "../figs/svgs/back.svg";
import { ReactComponent as LocationIcon } from "../figs/svgs/location.svg";
import { ReactComponent as OrganizationSettingsIcon } from "../figs/svgs/organization-settings.svg";
import { ReactComponent as EditIcon } from "../figs/svgs/pencil.svg";
import { ReactComponent as ProfileIcon } from "../figs/svgs/profile.svg";
import { ReactComponent as ReportIcon } from "../figs/svgs/report.svg";
import { ReactComponent as TourManagementIcon } from "../figs/svgs/tour-management.svg";
import { ReactComponent as DateManagementIcon } from "../figs/svgs/date-management.svg";
import { ReactComponent as AddIcon } from "../figs/svgs/add.svg";
import { ReactComponent as CloseIcon } from "../figs/svgs/close.svg";
import { ReactComponent as FillAddIcon } from "../figs/svgs/fill-add.svg";
import { ReactComponent as MinusIcon } from "../figs/svgs/minus.svg";
import { ReactComponent as SearchIcon } from "../figs/svgs/search.svg";
import { ReactComponent as BlueButton1Icon } from "../figs/svgs/blue-button-1.svg";
import { ReactComponent as BlueButton2Icon } from "../figs/svgs/blue-button-2.svg";
import { ReactComponent as BagIcon } from "../figs/svgs/bag.svg";
import { ReactComponent as GrayCalendarIcon } from "../figs/svgs/gray-calendar.svg";
import { ReactComponent as GrayClockIcon } from "../figs/svgs/gray-clock.svg";
import { ReactComponent as GrayLocationIcon } from "../figs/svgs/gray-location.svg";
import { ReactComponent as QrCodeIcon } from "../figs/svgs/qrcode.svg";

// สร้างอ็อบเจ็กต์ที่แมปชื่อ iconName กับ React Components
const svgs = {
  logo: LogoIcon,
  bg: BgIcon,
  delete: DeleteIcon,
  delete_2: DeleteIcon2,
  boat_settings: BoatSettingsIcon,
  boat: BoatIcon,
  calendar: CalendarIcon,
  clock: ClockIcon,
  data_edit: DataEditIcon,
  data_entry: DataEntryIcon,
  empty_image: EmptyImageIcon,
  empty_noti: EmptyNotiIcon,
  has_noti: HasNotiIcon,
  home: HomeIcon,
  back: BackIcon,
  location: LocationIcon,
  organization_settings: OrganizationSettingsIcon,
  edit: EditIcon,
  profile: ProfileIcon,
  report: ReportIcon,
  tour_management: TourManagementIcon,
  date_management: DateManagementIcon,
  add: AddIcon,
  close: CloseIcon,
  fill_add: FillAddIcon,
  minus: MinusIcon,
  search: SearchIcon,
  blue_button_1: BlueButton1Icon,
  blue_button_2: BlueButton2Icon,
  bag: BagIcon,
  gray_calendar: GrayCalendarIcon,
  gray_clock: GrayClockIcon,
  gray_location: GrayLocationIcon,
  qrcode: QrCodeIcon,
};

export default function Svg({ iconName, className = "" }) {
  const IconComponent = svgs[iconName]; // เลือก component ตามชื่อ iconName ที่ส่งมา
  return IconComponent ? (
    <>
      <IconComponent className={className} />
    </>
  ) : null; // แสดง SVG Component
}
